// Known JSONB column names — values should be passed through as-is (no key
// transformation) because they contain user-defined or structured data whose
// keys must not be mutated.
const JSONB_PASSTHROUGH = new Set([
  'suitability_matters',
  'suitabilityMatters',
  'custom_fields',
  'customFields',
  'brand_config',
  'brandConfig',
  'primary_address',
  'primaryAddress',
  'postal_address',
  'postalAddress',
  'emergency_contacts',
  'emergencyContacts',
  'scores',
  // Assessment worksheet answers are keyed by question id (snake_case) —
  // camelCasing the map keys orphans every saved answer on reload.
  'responses',
  // Reassessment preview/context RPCs return the same question-keyed answer
  // maps under these wrappers. Preserve their inner keys so an untouched
  // carried answer compares equal to its source in the review workstation.
  'carried_responses',
  'carriedResponses',
  'source_carried_responses',
  'sourceCarriedResponses',
  'consent_forms',
  'consentForms',
  'metadata',
  'config',
  'portal_config',
  'portalConfig',
  'services_included',
  'servicesIncluded',
  'gps_clock_in',
  'gpsClockIn',
  'gps_clock_out',
  'gpsClockOut',
  'attachments',
  'settings',
  'qualifications',
  'availability',
  'home_address',
  'homeAddress',
  'mandatory_training',
  'mandatoryTraining',
  'checks',
  'items',
  'tasks_completed',
  'tasksCompleted',
  'claimed_value',
  'claimedValue',
  'original_value',
  'originalValue',
  'wound_bed_percentages',
  'woundBedPercentages',
  's8_reconciliation',
  's8Reconciliation',
  'allowances',
  'allowances_breakdown',
  'allowancesBreakdown',
  'services_delivered_detail',
  'applies_to',
  'appliesTo',
  'sections',
  'workflow_config',
  'workflowConfig',
  'review_config',
  'reviewConfig',
  'portal_config',
  'portalConfig',
  'worker_config',
  'workerConfig',
  'document_config',
  'documentConfig',
]);

// Helper to transform snake_case keys to camelCase
export function toCamel(obj: any): any {
  if (Array.isArray(obj)) return obj.map(toCamel);
  if (obj !== null && typeof obj === 'object') {
    const result: Record<string, any> = {};
    for (const [key, value] of Object.entries(obj)) {
      const camelKey = key.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());
      if (JSONB_PASSTHROUGH.has(key) || JSONB_PASSTHROUGH.has(camelKey)) {
        result[camelKey] = value; // Don't recurse — preserve original JSONB structure
      } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        result[camelKey] = toCamel(value);
      } else if (Array.isArray(value)) {
        result[camelKey] = value.map((item) =>
          typeof item === 'object' && item !== null ? toCamel(item) : item,
        );
      } else {
        result[camelKey] = value;
      }
    }
    return result;
  }
  return obj;
}
